export enum EFortiAnalyzerModuleTabs {
  Traffic = 'traffic',
  Security = 'security',
}

export type FortiAnalyzerTabItem = {
  label: string;
  value: EFortiAnalyzerModuleTabs;
  description?: string;
  noDescription?: boolean;
};

export const defaultFortiAnalyzerTabItems: FortiAnalyzerTabItem[] = [
  {
    label: 'Traffic',
    value: EFortiAnalyzerModuleTabs.Traffic,
    description:
      'Network utilization and top talkers — bandwidth, sessions, active users, and the applications, websites, and hosts driving your perimeter traffic.',
  },
  {
    label: 'Security',
    value: EFortiAnalyzerModuleTabs.Security,
    description:
      'Malware, botnet, and intrusion activity detected at the perimeter — threat volume, compromised hosts, and the signatures, sources, and targets behind them.',
  },
];
